import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { SiteConfigProvider } from "@/lib/siteConfig";

import Landing from "@/pages/Landing";
import HealthForm from "@/pages/HealthForm";
import LifeForm from "@/pages/LifeForm";
import SubmissionSuccess from "@/pages/SubmissionSuccess";
import ClientTracker from "@/pages/ClientTracker";
import AgentLogin from "@/pages/AgentLogin";
import AgentDashboard from "@/pages/AgentDashboard";
import ClientsList from "@/pages/ClientsList";
import ClientDetail from "@/pages/ClientDetail";
import AgentsManagement from "@/pages/AgentsManagement";
import Settings from "@/pages/Settings";
import AgentLayout from "@/components/AgentLayout";

function ProtectedRoute({ children }) {
  const { agent, loading } = useAuth();
  if (loading) return null;
  if (!agent) return <Navigate to="/agent/login" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { agent, loading } = useAuth();
  if (loading) return null;
  if (!agent) return <Navigate to="/agent/login" replace />;
  if (agent.role !== "admin") return <Navigate to="/agent" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SiteConfigProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/apply/health" element={<HealthForm />} />
            <Route path="/apply/life" element={<LifeForm />} />
            <Route path="/apply/success" element={<SubmissionSuccess />} />
            <Route path="/track/:token" element={<ClientTracker />} />
            <Route path="/agent/login" element={<AgentLogin />} />
            <Route
              path="/agent"
              element={
                <ProtectedRoute>
                  <AgentLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AgentDashboard />} />
              <Route path="clients" element={<ClientsList />} />
              <Route path="clients/:id" element={<ClientDetail />} />
              <Route
                path="agents"
                element={
                  <AdminRoute>
                    <AgentsManagement />
                  </AdminRoute>
                }
              />
              <Route
                path="settings"
                element={
                  <AdminRoute>
                    <Settings />
                  </AdminRoute>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </SiteConfigProvider>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
